import { render, staticRenderFns } from "./Regsiter_Setting.vue?vue&type=template&id=28a60f1a&scoped=true"
import script from "./Regsiter_Setting.vue?vue&type=script&lang=js"
export * from "./Regsiter_Setting.vue?vue&type=script&lang=js"
import style0 from "./Regsiter_Setting.vue?vue&type=style&index=0&id=28a60f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a60f1a",
  null
  
)

export default component.exports